// import Vue from 'vue';
import Utility from "../../js/utility";
import BaseModule from '../_base_module';
import training_sessions from "./training_sessions";
import { ref } from 'vue'

// initial state
// shape: [{ id, quantity }]
const state = {
  ...BaseModule.state,

  hasBeenRedirected: false,
  data: {
    is_admin: 0,
    training_sessions: {
      data: {}
    }
  },
  access_token: {
    token: '',
    expires_at: '',
  },
};
const base_state = {
  ...BaseModule.state,

  hasBeenRedirected: false,
  data: {
    is_admin: 0,
    training_sessions: {
      data: {}
    }
  },
  access_token: {
    token: '',
    expires_at: '',
  },
  origin_user: null
};

// getters
const getters = {
  ...BaseModule.getters,
  hasBeenRedirected(state, getters, rootState, rootGetters) {
    return state.hasBeenRedirected;
  },
  missing_naw(state, getters, rootState, rootGetters) {
    let missingNaw = false;
    if (!state.data.birthday) {
      missingNaw = true;
    }
    if (!state.data.postal_code) {
      missingNaw = true;
    }
    if (!state.data.street_address) {
      missingNaw = true;
    }
    if (!state.data.city) {
      missingNaw = true;
    }
    if (!state.data.phone_number) {
      missingNaw = true;
    }
    return missingNaw;
  },
  activity(state, getters, rootState, rootGetters) {
    return (activity_id, training_session_id) => {
      return state.data.training_sessions.data[parseInt(training_session_id)].activities.data[parseInt(activity_id)];
    };
  },
  training_session(state, getters, rootState, rootGetters) {
    return (id) => {
      return getters.training_sessions[id];
    };
  },
  training_sessions(state, getters, rootState, rootGetters) {
    return state.data.training_sessions.data;
  },
  training_session_ids_reversed(state, getters, rootState, rootGetters) {
    return Object.keys(getters.training_sessions).sort((a, b) => b - a);
  },
  last_four_training_sessions(state, getters, rootState, rootGetters) {
    let last_unique_training_sessions = [];

    getters.training_session_ids_reversed.forEach(training_session_id => {
      let training_session = state.data.training_sessions.data[training_session_id];
      // When the name is unique (not yet in the index), we add it to the array
      if(Utility.find_index_of_matching_value(last_unique_training_sessions, training_session.name) === -1) {
        last_unique_training_sessions.push(training_session);
      }
    });

    return last_unique_training_sessions.splice(0,4);
  },
  id(state, getters, rootState, rootGetters) {
    return state.data.id;
  },
  token(state, getters, rootState, rootGetters) {
    return state.access_token.token;
  },
  credits(state, getters, rootState, rootGetters) {
    return state.data.credits;
  },
  isLoggedIn(state, getters, rootState, rootGetters) {
    return getters['token'].length > 0;
  }
};

// actions
const actions = {
  ...BaseModule.actions,
  hasBeenRedirected({state, commit, dispatch, getters, rootState}, payload) {
    state.hasBeenRedirected = true;
    setTimeout(() => {
      state.hasBeenRedirected = false;
    }, 300);
  },
  login({state, commit, dispatch, getters, rootState}, payload) {

    commit('app/show_loader', {}, {root: true});

    return dispatch('api/postEndpoint', {
      endpoint: '/login',
      data: payload,
    }, {root: true}).then((response) => {
      commit('set_state', {property: 'access_token', value: response.data.access_token});

      dispatch('set_current_user', response.data.current_user);

    }).finally(response => {
      commit('app/hide_loader', {}, {root: true});
    });
  },
  async logout({state, commit, dispatch, getters, rootState}, payload) {
    // PUSH-04. Unregister this device BEFORE clearing the access token -- the
    // DELETE is an authenticated call, so clearing first would leave the token
    // on the server and the member would keep receiving notifications on a
    // device they logged out of. Awaited for the same reason.
    //
    // push/unregister never rejects: a logout must not fail because the device
    // could not be unregistered. Worst case the server keeps a token its own
    // reaper deletes on first failed send.
    await dispatch('push/unregister', null, {root: true});

    // Logging out is easy as just removing the user from store
    commit('clear_all');
    commit('activities/clear', null, {root: true});
    commit('training_sessions/clear', null, {root: true});
    commit('training_slots/clear', null, {root: true});
    commit('news/clear', null, {root: true});
    // Account state, and it must not outlive the account session. vuex-persist runs with
    // no reducer (src/store/index.js), so the whole store -- this module included -- is
    // mirrored into localStorage. Without this line the next member to log in on a shared
    // phone renders the previous member's notification toggles straight out of the cache,
    // before the fetch returns. Note push/unregister above is the opposite case: push is
    // device state and deliberately survives.
    commit('notification_preferences/clear', null, {root: true});
    // Stage configuration is NOT member data -- it is six integers a super admin
    // edits -- so the reason here is staleness rather than privacy. Same defect
    // all the same: vuex-persist has no reducer, so `loaded: true` surviving a
    // logout makes the next visit to /admin/booking-stages skip its preloader and
    // paint the previous session's numbers, and a stale `saving: true` leaves the
    // save button disabled for somebody who never pressed it.
    commit('booking_stages/clear', null, {root: true});
  },
  forgot_password({state, commit, dispatch, getters, rootState}, payload) {

    commit('app/show_loader', {}, {root: true});

    return dispatch('api/postEndpoint', {
      endpoint: '/forgot-password',
      data: payload,
    }, {root: true}).then((response) => {
      dispatch('notifications/addSuccessNotification', response.data, {root: true});
    }).catch(error => {
      dispatch('notifications/addDangerNotification', error.data.data, {root: true});
    })
    .finally(response => {
      commit('app/hide_loader', {}, {root: true});
    });
  },
  reset_password({state, commit, dispatch, getters, rootState}, payload) {

    commit('app/show_loader', {}, {root: true});

    return dispatch('api/postEndpoint', {
      endpoint: '/reset-password',
      data: payload,
    }, {root: true}).then((response) => {
      dispatch('notifications/addSuccessNotification', response.data, {root: true});
    }).catch(error => {
      dispatch('notifications/addDangerNotification', error.data.data, {root: true});
    })
    .finally(response => {
      commit('app/hide_loader', {}, {root: true});
    });
  },
  impersonate({state, commit, dispatch, getters, rootState}, payload) {

    commit('app/show_loader', {}, {root: true});

    return dispatch('api/postEndpoint', {
      endpoint: '/users/impersonate/' + payload.user,
      data: payload,
    }, {root: true}).then((response) => {
      commit('set_state', {property: 'access_token', value: response.data.access_token});
      commit('set_state', {property: 'origin_user', value: response.data.origin_user});

      dispatch('set_current_user', response.data.current_user);

    }).finally(response => {
      commit('app/hide_loader', {}, {root: true});
    });
  },
  stop_impersonate({state, commit, dispatch, getters, rootState}, payload) {
    commit('app/show_loader', {}, {root: true});

    return dispatch('api/postEndpoint', {
      endpoint: '/users/impersonate/stop',
    }, {root: true}).then((response) => {
      commit('set_state', {property: 'access_token', value: response.data.access_token});
      commit('set_state', {property: 'origin_user', value: null});

      dispatch('set_current_user', response.data.current_user);

    }).finally(response => {
      commit('app/hide_loader', {}, {root: true});
    });
  },

  fetch({state, commit, dispatch, getters, rootState}, payload) {
    commit('app/show_loader', {}, {root: true});
    console.log('current_user/fetch');
    dispatch('api/getEndpoint', {
      endpoint: '/current-user',
      data: payload,
    }, {root: true}).then((response) => {
      dispatch('set_current_user', response.data.data).finally(response => {
        commit('app/hide_loader', {}, {root: true});
      }).then(response => {
      }).catch(error => {
        //
      });
    }).catch(error => {
      // dispatch('logout');
    });

  },
  set_current_user({state, commit, dispatch, getters, rootState}, current_user) {
    commit('set_state', {property: 'data', value: current_user});

    let new_current_user = Utility.deep_clone(current_user);

    // En updaten we direct alle training_sessions:
    new_current_user.training_sessions.forEach(training_session => {
      dispatch('training_sessions/add_to_store', training_session, {root:true})
    });
  },

  // create_training_session({state, commit, dispatch, getters, rootState}, payload) {
  //   return dispatch('api/postEndpoint', {
  //     endpoint: '/users/' + getters.id + '/training-sessions',
  //     data: payload,
  //   }, {root: true}).then((response) => {
  //     commit('update_training_session', response.data.data);
  //
  //     return response.data.data;
  //   });
  // },
  update_training_session({state, commit, dispatch, getters, rootState}, payload) {
    payload.user_id = getters.id;
    return dispatch('training_sessions/update', payload, {root: true}).then(training_session => {

      commit('update_training_session', training_session);

    });
  },
  copy_training_session({state, commit, dispatch, getters, rootState}, payload) {
    return dispatch('training_sessions/copy', {
      user_id: getters.id,
      training_session_id: payload.training_session_id,
    }, {root: true});
  },
  destroy_training_session({state, commit, dispatch, getters, rootState}, payload) {
    payload.user_id = getters.id;
    dispatch('training_sessions/destroy', payload, {root: true}).then(() => {

      let updated_training_sessions = getters.training_sessions;
      updated_training_sessions = updated_training_sessions.filter(training_session => {
        return training_session.id !== payload.training_session_id;
      })

      commit('set_training_sessions', updated_training_sessions);
    });
  },

  store_activity({state, commit, dispatch, getters, rootState}, payload) {
    payload.user_id = getters.id;

    dispatch('activities/store', payload, {root:true}).then(training_session => {

      commit('update_training_session', training_session);

    });
  },
  update_activity({state, commit, dispatch, getters, rootState}, payload) {
    payload.user_id = getters.id;

    dispatch('activities/update', payload, {root:true}).then(training_session => {
      commit('update_training_session', training_session);
    });
  },
  destroy_activity({state, commit, dispatch, getters, rootState}, payload) {
    payload.user_id = getters.id;
    dispatch('activities/destroy', payload, {root:true}).then((training_session) => {
      commit('update_training_session', training_session);
    });
  },
  fetch_training_slots ({state, commit, dispatch, getters, rootState}, payload) {
    return dispatch('api/getEndpoint', {
      endpoint: '/users/' + getters.id + '/training-slots',
      data: payload,
    }, {root: true}).then(response => {
      return response.data.data;
    });
  },
  open_door({state, commit, dispatch, getters, rootState}, payload) {
    // api/v1
    return dispatch('api/postEndpoint', {
      endpoint: '/users/'+getters.id +'/gyms/'+payload.gym_id+'/training-slots/'+payload.training_slot_id,
      data: payload,
    }, {root: true}).then(response => {
      console.log('current_user/open_door', response);
      return response.data.data;
    });
  },
};

// mutations
const mutations = {
  ...BaseModule.mutations,
  // update_activity(state, payload) {
  //   state.data.training_sessions.data[payload.training_session_id].activities.data = { ...state.data.training_sessions.data[payload.training_session_id].activities.data, [payload.activity.id]: payload.activity }
  //
  //   // Vue.set(state.data.training_sessions.data[payload.training_session_id].activities.data, payload.activity.id, payload.activity);
  // },
  update_training_session(state, updated_training_session) {
    state.data.training_sessions.data = { ...state.data.training_sessions.data, [updated_training_session.id]: updated_training_session }

    // Vue.set(state.data.training_sessions.data, updated_training_session.id, updated_training_session);
  },
  set_training_sessions(state, training_sessions) {
    state.data.training_sessions = { ...state.data.training_sessions, data: training_sessions }

    // Vue.set(state.data.training_sessions, 'data', training_sessions);
  },
  clear_token(state) {
    state.access_token = { ...state.access_token, token: ''}

    // Vue.set(state.access_token, 'token', '');
  },
  clear_all(state, getters, rootState, rootGetters) {
    Object.keys(base_state).forEach(key => {
      state[key] = base_state[key];
    })
  }
};

export default {

  namespaced: true,

  state,
  getters,
  actions,
  mutations,

};
